import React from 'react';
import { Button, Modal, Form, Input, Icon, Row, Col } from 'antd';
import { observer, inject } from 'mobx-react';
import UploadFile from '../UploadFile';
const FormItem = Form.Item;

@inject('appFileStore')
@observer
class AddAppForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: ''
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.changeFileName = this.changeFileName.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }
  onSubmit() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        const form = new FormData();
        form.append('app_description', value.description);
        form.append('file', value.file);
        this.props.appFileStore.addApp(form);
        this.props.form.resetFields();
        this.setState({ fileName: '' });
      }
    });
  }
  changeFileName(file) {
    this.setState({
      fileName: (file || {}).name || ''
    });
  }
  hideModal() {
    this.props.hideAppModal();
    this.props.form.resetFields();
    this.setState({
      fileName: ''
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { appModal, hideAppModal } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      }
    };
    return (
      <div>
        <Modal
          title="新增App"
          visible={appModal}
          onOk={this.onSubmit}
          onCancel={this.hideModal}
          okText="确认"
          cancelText="取消"
          width={'50%'}
        >
          {appModal ? (
            <Form onSubmit={this.onSubmit}>
              <FormItem {...formItemLayout} label="App描述">
                {getFieldDecorator('description', {
                  rules: [{ required: true, message: '请输入App描述!' }]
                })(<Input placeholder="请输入App描述" />)}
              </FormItem>
              <FormItem {...formItemLayout} label="选择上传安装包">
                {getFieldDecorator('file', {
                  rules: [{ required: true, message: '请选择上传安装包!' }]
                })(
                  <UploadFile
                    callback={this.changeFileName}
                    fileName="选择安装包文件"
                  />
                )}
              </FormItem>
            </Form>
          ) : null}

          <Row>
            <Col offset={8} span={16}>
              {this.state.fileName && (
                <p>
                  {' '}
                  <Icon type="file-add" /> {this.state.fileName}
                </p>
              )}
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

const AddApp = Form.create()(AddAppForm);
export default AddApp;



// WEBPACK FOOTER //
// ./src/components/AppFile/AddApp.js